import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {SiteDetailsService} from '../../../services/site-details.service';
import {SitesManager} from '../../../common/elf-store/sites/sites.manager';
import {PaginationService} from 'src/app/services/pagination.service';
import {UserPermissions} from 'src/app/common/elf-store/user-permissions/user-permissions.store';
import {ProductStatus, SiteSearchEntryDto} from '../../../../userway/sdk/UserWayApiClient';

@Component({
  selector: 'mc-site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.scss'],
})
export class SiteListComponent {
  @Input() sites: SiteSearchEntryDto[];
  @Input() showHead: boolean = false;
  @Output() addNewSite = new EventEmitter<Event>();
  @Output() manageSite = new EventEmitter<Event>();
  @Output() goToAllSites = new EventEmitter<Event>();
  @Output() goToEmbedCode = new EventEmitter<Event>();
  @Output() lastElementBlur = new EventEmitter<FocusEvent>();
  readonly iconStaticUrl: string = 'https://s2.googleusercontent.com/s2/favicons?domain=';
  ProductStatus = ProductStatus;
  constructor(
    private router: Router,
    public overviewSiteService: SiteDetailsService,
    private sitesManager: SitesManager,
    private paginationService: PaginationService,
  ) {}

  get UserPermissions() {
    return UserPermissions;
  }

  openViewSite(event: Event, site: SiteSearchEntryDto): void {
    this.router.navigate(
      [`widget/${this.paginationService.currentTab}/p/${this.paginationService.currentPage}/site-details/overview`],
      {
        queryParams: {site: site.host},
        queryParamsHandling: 'merge',
      },
    );
    this.sitesManager.setCurrentSite(site);
    this.manageSite.emit(event);
  }

  openAccountMismatch(event: Event, site: SiteSearchEntryDto): void {
    event.stopPropagation();
    this.router.navigate(
      [`widget/${this.paginationService.currentTab}/p/${this.paginationService.currentPage}/account-mismatch`],
      {
        queryParams: {site: site.host},
        queryParamsHandling: 'merge',
      },
    );
    this.sitesManager.setCurrentSite(site);
    this.manageSite.emit(event);
  }

  openAccessibilityWidget(event: Event) {
    void this.router.navigate(['widget']);
    this.goToAllSites.emit(event);
  }

  handleSiteClick(event: Event, site: SiteSearchEntryDto): void {
    if (this.overviewSiteService.hasIdMismatch(site)) {
      this.openAccountMismatch(event, site);
    } else {
      this.openViewSite(event, site);
    }
  }
}
